import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LayoutService } from 'src/app/layout/layout.service';
import { AuthService } from 'src/app/services/auth.service';
import { GatemanService } from 'src/app/services/gateman.service';
import { PageService } from 'src/app/services/page.service';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
})
export class AuthComponent implements OnInit {
  @Input() data;
  @Input() controls;
  @Input() config;

  sandbox: boolean = false;
  isLoggedIn: boolean = false;
  noAccessMessage: Array<any> = [];
  providers: Array<string> = [];
  authDomain: string = '';
  constructor(
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private pageService: PageService,
    private layoutService: LayoutService,
    private router: Router,
    
  ) { }

  ngOnInit() {
    this.sandbox = this.activatedRoute.snapshot.queryParams.sandbox;
    this.authDomain = this.authService.getAuthDomain(this.layoutService.vdi);
   
    //console.log(this.authDomain);
    if(this.authDomain == 'localhost') {
      this.authService.authDomain = environment.authDomain;
    } else {
      this.authService.authDomain = this.authDomain;
    }

    // console.log('authDomain',this.authService.authDomain);
    // console.log(environment.authDomain)
    // debugger;
   // console.log(environment);

    const { message } = this.config;
    this.noAccessMessage = message;
    this.isLoggedIn = this.authService.isLoggedIn;

    this.providers = this.getProviders(this.authService.providers, this.pageService.diLayout);

    
  }

  /**
   * Navigate to auth domain
   * @author Neil C 
   * @task QLIKTAG-4052
   */
  signIn(provider) {
    const queryParams = {
      _p: provider,
      _r: encodeURIComponent(location.href)
    };
  
    console.log('Current location:', location.href);
    console.log('Query Params:', queryParams);
  
    if (this.authDomain === 'localhost') {
      console.log('Navigating to sign-in with queryParams:', queryParams);
      this.router.navigate(['sign-in'], { queryParams });
    } else {
      const url = new URL(`${this.authDomain}/sign-in`);
      const { _p, _r } = queryParams;
      url.searchParams.set('_p', _p);
      url.searchParams.set('_r', _r);
  
      console.log('Redirecting to URL:', url.toString());
      location.href = url.toString();
    }
  }
  

  /**
   * Return a filtered list of sign-in providers
   * @param list Available providers
   * @author Neil C 
   * @task QLIKTAG-4052
   * @returns 
   */
  getProviders(list, layout) {
    let result = [];
    const { advanced } = layout;
    if(advanced) {
      const { auth } = advanced;
      if(auth) {
        const { authProviders } = auth;
         if(authProviders.length) {
          result = list.filter((provider) => {
            return authProviders.indexOf(provider) != -1 ?  true : false;
          });

        }

      }
    }
    return result;
  }

}
